// extracted by mini-css-extract-plugin
export default {"border":"CollapsibleDropdown_border__lOepk","container":"CollapsibleDropdown_container__QsTR6","collapsed":"CollapsibleDropdown_collapsed__IxuKX"};